var exports = {
  "lm": "ThreadComposerArea.module__notice___YUFvQU",
  "EP": "ThreadComposerArea.module__noticeIcon___YUFvQU",
  "ut": "ThreadComposerArea.module__noticeText___YUFvQU",
  "Sx": "ThreadComposerArea.module__lockedIcon___YUFvQU",
  "WG": "ThreadComposerArea.module__alsoSend___YUFvQU",
};

module.exports = exports;
